import * as Color from 'color';

export function toTailwindCompatibleChannels(color: string) {
  return new Color(color)
    .rgb()
    .array()
    .join(' ');
}
